export const fromNostrURI = (s) => s.replace(/^nostr:\/?\/?/, "");
export const toNostrURI = (s) => (s.startsWith("nostr:") ? s : `nostr:${s}`);
//# sourceMappingURL=Links.js.map